/**
 * Botón flotante de soporte por WhatsApp (feedback 3 de Alex: "un botón para
 * hablar con nosotros"). Vive fijo abajo a la derecha en todas las pantallas y
 * abre WhatsApp con un mensaje ya escrito. Va aparte del panel de ayuda a
 * proposito (documento de Alex, 5 sep 2026): la ayuda son tutoriales y
 * Alexia; aqui contesta una persona. El numero esta aqui, en un solo sitio.
 */

// +1 (915) 499-0347 — solo dígitos para el enlace de WhatsApp.
const WHATSAPP_NUMBER = '19154990347';
const MENSAJE = 'Hola, necesito ayuda con Alexia Rest';

export const WHATSAPP_HREF = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(MENSAJE)}`;

export function SupportButton(): JSX.Element {
  return (
    <a
      className="wa-support"
      href={WHATSAPP_HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Soporte por WhatsApp"
      title="Escríbenos por WhatsApp"
      data-tour="soporte"
    >
      <IconoWhatsApp />
      <span className="wa-support__label">Soporte</span>
    </a>
  );
}

export function IconoWhatsApp(): JSX.Element {
  return (
    <svg
      className="wa-support__icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M17.5 14.4c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35zM12.05 21.5h-.01a9.42 9.42 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.42 9.42 0 0 1-1.44-5.01c0-5.2 4.24-9.44 9.46-9.44 2.53 0 4.9.99 6.68 2.78a9.38 9.38 0 0 1 2.77 6.67c0 5.2-4.24 9.45-9.45 9.45zM20.4 3.6A11.36 11.36 0 0 0 12.05 0C5.5 0 .17 5.33.17 11.88c0 2.09.55 4.14 1.6 5.94L.07 24l6.34-1.66a11.85 11.85 0 0 0 5.64 1.44h.01c6.55 0 11.88-5.33 11.88-11.88 0-3.17-1.24-6.15-3.48-8.39z" />
    </svg>
  );
}

export default SupportButton;
